import {
  SET_SOURCE_ROUTE,
  RESET_SOURCE_ROUTE,
  SESSION_EXPIRE,
} from '../actionTypes';

import {
  USER_SIGN_OUT,
} from '../../user/actionTypes';

let initialState = {
  source: '/',
  sessionExpired: false, // TODO: find a cleaner implementation
}

// the idea here is that we set a source route so the
// child/grandchild pages with multiple source of entrance
// will have an idea on where to return.
// there might be a better way to implement this
export default function routes(state = initialState, action) {
  switch(action.type) {
    case SET_SOURCE_ROUTE:
      return { ...state, source: action.payload };
    case RESET_SOURCE_ROUTE:
      return { ...state, source: '/' };
    case SESSION_EXPIRE:
      return { ...state, sessionExpired: true }
    case USER_SIGN_OUT:
      return { ...state, sessionExpired: false }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/shared/reducers/routes.js